module.exports = __webpack_public_path__ + "img/size.ebef343a.jpg";